module.exports = {
  comingsoon: {
    pagename: 'comingsoon',
    name: 'Coming Soon',
    description:
      'Will add apps soon. Most are under NDA, so I will add the ones I am allowed to show.',
    livelink: null,
    github: null,
    img: 'thumb-vannya-me.png',
    fullimg: 'website-vannya-me.png'
  }
};
